import { useState } from 'react';
import { type IGcfProductListGroups } from 'src/interfaces';

export const useSingleShelfForm = () => {
  const [cacheGcfGroups, setCacheGcfGroups] = useState<IGcfProductListGroups>();
  const [openBackgroundDrawer, setOpenBackgroundDrawer] = useState(false);
  const [openTitleDrawer, setOpenTitleDrawer] = useState(false);
  const [openSettingsDrawer, setOpenSettingsDrawer] = useState(false);
  const [openProductsDrawer, setOpenProductsDrawer] = useState(false);

  const onToggleBackgroundDrawer = () =>
    setOpenBackgroundDrawer(!openBackgroundDrawer);

  const onToggleTitleDrawer = () => setOpenTitleDrawer(!openTitleDrawer);

  const onToggleSettingsDrawer = () =>
    setOpenSettingsDrawer(!openSettingsDrawer);

  const onToggleProductsDrawer = () =>
    setOpenProductsDrawer(!openProductsDrawer);

  return {
    openBackgroundDrawer,
    openTitleDrawer,
    openSettingsDrawer,
    openProductsDrawer,
    cacheGcfGroups,
    onToggleBackgroundDrawer,
    onToggleTitleDrawer,
    onToggleSettingsDrawer,
    onToggleProductsDrawer,
    setCacheGcfGroups,
  };
};
